module.exports = __webpack_public_path__ + "files/ed280860ea92dab5be253eab43128865.svg";